// Using Vue for the product quantities
// Get the divisible property, from the Tag
let perBox = document.getElementById('perBox') ? document.getElementById('perBox').value : 0;
let price = document.getElementById('currentPrice').innerHTML;
var measureUnit = document.getElementById('measureUnit').value;

var elements = document.querySelectorAll('.product-addons__details');
var addOnProducts = [];
elements.forEach(function(item) {
  addOnProducts.push({
    id: item.dataset['id'],
    price: item.dataset['price']
  })
})

new Vue({
  el: '#LFTquantities',
  data: function () {
    return {
      normalQty: null,
      lftQty: null,
      boxQty: null,
      addOnsQty: {},
    }
  },
  computed: 
  {
    totalPrice() {
      var addOnPrices = 0;
      var basePrice = 0;
      var self = this;
      if (measureUnit === 'panel') {
        basePrice = this.lftQty * price;
        addOnProducts.forEach(function(product) {
          var qty = self.addOnsQty[product.id] ? self.addOnsQty[product.id] : 0;
          var addOnPrice = product.price * qty;
          addOnPrices += addOnPrice;
        })
        basePrice = 0;
      } else if (measureUnit === 'box') {
        basePrice = this.boxQty * price;
      } else {
        basePrice = this.normalQty * price;
      }
      var sum = basePrice + addOnPrices;
      return sum.toFixed(2);
    },
    totalLFTQty() {
      return totalLFT.linearFeet;
    }
  },
  watch: {
    totalLFTQty(newV) {
      this.lftQty = newV;
      if (measureUnit === 'panel') {
        this.updateAddOnsQty();
      }
      if (measureUnit === 'box') {
        this.boxQty = Math.ceil(this.lftQty / perBox);
      }
    },
  },
  methods:
  {
    updateBoxQty(event) {
      this.boxQty = Number(event.target.value);
      this.lftQty = this.boxQty * perBox;
    },
    updateQty(event) {
      this.normalQty = Number(event.target.value);
    },
    updateAddOnsQty() {
      var self = this;
      var variantsCount = addOnProducts.length;
      addOnProducts.forEach(function (product) {
        self.addOnsQty[product.id] = Math.ceil(self.lftQty / (variantsCount * perBox));
      });
      console.log('------ this self.addOnsQt;', self.addOnsQty)
    },
    // LFT QTY change
    onLFTChange(event) {
      this.lftQty = Number(event.target.value);
      if (measureUnit === 'box') {
        this.boxQty = Math.ceil(this.lftQty / perBox);
      } else {
        this.updateAddOnsQty();
      }
    },
    // Hardwares QTY change
    plusQty(variant_id) {
      if (this.addOnsQty[variant_id]) {
        this.addOnsQty[variant_id]++;
      } else {
        this.addOnsQty[variant_id] = 1;
      }
      this.addOnsQty = { ...this.addOnsQty }
    },
    // Hardwares QTY change
    minusQty(variant_id) {
      if (this.addOnsQty[variant_id] || this.addOnsQty[variant_id] > 1) {
        this.addOnsQty[variant_id]--;
      } else {
        this.addOnsQty[variant_id] = 0;
      }
      this.addOnsQty = { ...this.addOnsQty }
    },
  }
})

